import React from 'react'
import BuiltSizeImg from '../../../assets/images/information/built-and-size.png'

const InfoBuiltSize = () => {
  return (
    <div>
        <div className='content-text'>
            Choose <span>width, length, and height</span> to start. Default options reflect the building provider’s recommendations. Customize your build further with <span>roof style, pitch, and gauge</span> on this tab.
        </div>
        <div className='mt-4'>
            <img src={process.env.REACT_APP_BASE_URL+BuiltSizeImg} className='general-img' alt='built-size'></img>
        </div>
    </div>
  )
}

export default InfoBuiltSize